import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "../store";
import {
  CommonModalPayload,
  CommonModalState,
} from "../../common/types/interfaces";
import { CommonModals } from "../../common/types/enums";

const initialState: { data: CommonModalState } = {
  data: {
    [CommonModals.LOGIN]: false,
    [CommonModals.PAYMENT]: false,
    [CommonModals.STATUS_MENU]: false,
    [CommonModals.CHAT_MENU]: false,
    [CommonModals.FILTER]: false,
    [CommonModals.SORT]: false,
    [CommonModals.LOADER]: false,
    [CommonModals.CITY_SELECT]: false,
  },
};

export const commonModalSlice = createSlice({
  name: "common-modal",
  initialState,
  reducers: {
    setCommonModalState: (state, action: PayloadAction<CommonModalPayload>) => {
      state.data[action.payload.modal] = action.payload.state;
    },
  },
});

export const { setCommonModalState } = commonModalSlice.actions;

export const selectModalState = (state: RootState, field: CommonModals) =>
  state.commonModal.data[field];

export default commonModalSlice.reducer;
